import { Container, Paper, Stack, Typography } from '@mui/material';
import {useGetMeQuery} from "../apis/CurrentUser.api";
import useAuth from "../hooks/useAuth";
import Grid from '@mui/material/Grid';
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ProfilePage = () => {

    useTitle(t`Profile`);
    
    const { session } = useAuth()
    const { data: user } = useGetMeQuery();

    return (
        <Paper sx={ { padding: "2em" } }>
            <Container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Stack direction="column" spacing={3}>
                    <Typography component='h2' variant='h2' sx={{ textAlign: 'center' }}>
                        <Trans>Profile Page</Trans>
                    </Typography>

                    <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } } sx={{ maxWidth: '27rem' }}>
                        <Grid size={{xs: 4}} sx={{ textAlign: "left" }}>
                            <Trans>Id</Trans>:
                        </Grid>
                        <Grid size={{xs: 8}} sx={{ textAlign: "left" }}>
                            {user?.id}
                        </Grid>
                        <Grid size={{xs: 4}} sx={{ textAlign: "left" }}>
                            <Trans>Full Name</Trans>:
                        </Grid>
                        <Grid size={{xs: 8}} sx={{ textAlign: "left" }}>
                            {user?.name || '-'}
                        </Grid>
                        <Grid size={{xs: 4}} sx={{ textAlign: "left" }}>
                            <Trans>Email Address</Trans>:
                        </Grid>
                        <Grid size={{xs: 8}} sx={{ textAlign: "left" }}>
                            {user?.email || '-'}
                        </Grid>
                    </Grid>
                </Stack>
            </Container>
        </Paper>
    );
};

export default ProfilePage;
